<%= form_with(model: user, class: "contents") do |form| %>
  <% if user.errors.any? %>
    <div id="error_explanation" class="bg-red-50 text-red-500 px-3 py-2 font-medium rounded-md mt-3">
      <h2><%= pluralize(user.errors.count, "error") %> prohibited this user from being saved:</h2>

      <ul class="list-disc ml-6">
        <% user.errors.each do |error| %>
          <li><%= error.full_message %></li>
        <% end %>
      </ul>
    </div>
  <% end %>

  <div class="my-5">
    <%= form.label :userid %>
    <%= form.text_field :userid, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": user.errors[:userid].none?, "border-red-400 focus:outline-red-600": user.errors[:userid].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :email %>
    <%= form.text_field :email, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": user.errors[:email].none?, "border-red-400 focus:outline-red-600": user.errors[:email].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :name1 %>
    <%= form.text_field :name1, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": user.errors[:name1].none?, "border-red-400 focus:outline-red-600": user.errors[:name1].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :name2 %>
    <%= form.text_field :name2, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": user.errors[:name2].none?, "border-red-400 focus:outline-red-600": user.errors[:name2].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :password %>
    <%= form.text_field :password, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": user.errors[:password].none?, "border-red-400 focus:outline-red-600": user.errors[:password].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :token %>
    <%= form.text_field :token, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": user.errors[:token].none?, "border-red-400 focus:outline-red-600": user.errors[:token].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :link %>
    <%= form.text_field :link, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": user.errors[:link].none?, "border-red-400 focus:outline-red-600": user.errors[:link].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :sites %>
    <%= form.text_field :sites, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": user.errors[:sites].none?, "border-red-400 focus:outline-red-600": user.errors[:sites].any?}] %>
  </div>

  <div class="inline">
    <%= form.submit class: "w-full sm:w-auto rounded-md px-3.5 py-2.5 bg-blue-600 hover:bg-blue-500 text-white inline-block font-medium cursor-pointer" %>
  </div>
<% end %>
